/// <reference types="@angular/localize" />

import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as angular from 'angular';
import { setAngularJSGlobal } from '@angular/upgrade/static';

import { AppModule } from './app/app.module';

// 20260909 PAH - Import moved from appconfig.service.ts, which created circular imports
// Register Angular components and services that are consumed by the legacy AngularJS app.
import './app/core/services/downgraded.service';

import { UIRouter, UrlService } from "@uirouter/core";
import { environment } from './environments/environment';

import imAppModule from './ng-app/app.module.ajs';

const context = (import.meta as any).webpackContext('./ng-app/content',
  { recursive: true, regExp: /\.js$/ }
);

context.keys().forEach((file: any) => {
  try {
    context(file);
  } catch (err) {
    console.log(err, file);
  }
});

// Fix: We need to manually import modals that are not used in code, to avoid tree shaking
const modalContext = (import.meta as any).webpackContext('./app/modal', { recursive: true, regExp: /\.component\.ts$/, mode: 'sync' });
modalContext.keys().forEach(modalContext);

setAngularJSGlobal(angular);

imAppModule.config(['$urlServiceProvider', 'graphAuthServiceProvider', function ($urlService: UrlService) {
    // Using AngularJS config block, call `deferIntercept()`.
    // This tells UI-Router to delay the initial URL sync (until all bootstrapping is complete)
    $urlService.deferIntercept();
}]);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(platformRef => {
    // Intialize the Angular Module
    // get() the UIRouter instance from DI to initialize the router
    const urlService: UrlService = platformRef.injector.get(UIRouter).urlService;

    // Instruct UIRouter to listen to URL changes
    function startUIRouter() {
      urlService.listen();
      urlService.sync();
    }

    platformRef.injector.get<NgZone>(NgZone).run(startUIRouter);
  })
  .catch(err => console.log(err));
